<template>
  <div class="about">
    <!-- <Loading v-if="showLoading && !isMobile"></Loading> -->
    <div class="background-container-mobile" id="background-container-mobile" v-if="showLoading"></div>
    <div class="video-container">
        <div :data-vimeo-id="idVideo" id="handstick" class="video-player-container" v-show="!showLoading"></div>
        <div class="about-overlay scrollAnimationOverlay" id="about-overlay"></div>
        <section class="hero-slider">
          <div class="fullH scrollAnimation1">
          </div>
          <div class="slider-content d-flex flex-column justify-content-center fullH">
            <vue-typer class="text-white bcLiguria" text="Shaping the future" :repeat="0" v-if="!isMobile"></vue-typer>
            <span class="intro-text text-white bcLiguria" v-if="isMobile">Shaping the future of</span>
            <div class="d-flex flex-row height-mobile">
              <vue-typer text="of " :repeat="0" :pre-type-delay="1500" @completed="showHomeTyperLast = true"  v-if="!isMobile"/>
              <vue-typer :text="['Architects', 'Designers', 'Engineers', 'Techincal Specialist']" v-if="isMobile || showHomeTyperLast"
                        :type-delay="70" erase-style="clear" caret-animation='expand' />
            </div>
          </div>
          <div class="wrapper">
            <article class="mision-container scrollAnimation2 animationText">
              <div class="d-flex align-items-end fullH">
                <p class="text-white bcLiguria">{{$t('home.text')}}</p>
              </div>
            </article>
          </div>
          <div class="d-none d-md-block mouse-container" v-if="!isMobile">
            <MouseIcon v-if="sliderElemns.showMouse"></MouseIcon>
          </div>
        </section>
      <section class="about-sections-container scrollAnimation4">
          <AboutValues v-for="(values, id) in $t('about.values')" :key='id' :values="values" :id="id"/>
      </section>
      <section class="people">
        <div class="d-flex flex-column justify-content-center subtit">
          <p class="text-white">{{$t('team.text')}}</p>
        </div>
        <TeamList />
      </section>
    </div>
  </div>
</template>

<script>
import TeamList from '../components/TeamList'
import { fadeInOutSection, backgroundOverlay } from '@/assets/js/animations'
import MouseIcon from '../assets/img/mouse-icon.svg'
import { isMobileOnly, isIOS, isMobile } from 'mobile-device-detect'
import AboutValues from '../components/AboutValues.vue'
import { VueTyper } from 'vue-typer'
import Player from '@vimeo/player'
// import Loading from '../components/Loading'
import { EventBus } from '@/event-bus'
import Helper from '@/helpers/Helper'
export default {
  name: 'About',
  components: {
    // Loading,
    MouseIcon,
    VueTyper,
    AboutValues,
    TeamList
  },
  data () {
    return {
      isMobileOnly,
      isMobile,
      isIOS,
      idVideo: 1069436097,
      vimeoPlayer: null,
      showLoading: true,
      showHomeTyperLast: false,
      styleOverlay: {
        backgroundColor: 'rgba(0,0,0,0)'
      },
      sliderElemns: {
        showArrow: true,
        showMouse: true,
        showSliderInfo: true,
        showOverlay: true,
        showFloatingButtons: true
      },
      showPeople: false,
      people: null
    }
  },
  computed: {
    peopleToShow () {
      return (this.showPeople && Array.isArray(this.people)) ? this.people.filter(p => p.show) : []
    }
  },
  methods: {
    vimeoPlayerOnLoad () {
      this.vimeoPlayer = new Player('handstick', {
        id: this.idVideo,
        muted: true,
        controls: false,
        loop: true,
        responsive: true
      })

      this.vimeoPlayer.ready().then(() => {
        return this.vimeoPlayer.loadVideo(this.idVideo)
      }).then(() => {
        return this.vimeoPlayer.play()
      }).then(() => {
        this.showLoading = false
        this.$nextTick(() => window.scrollTo({ top: 0 }))
      }).catch(() => {
        // console.error('Error al cargar el video:', error)
        this.showLoading = false // Ocultar el loader en caso de error
      })
    },
    sortPeople () {
      this.people = [...this.people].sort(() => Math.random() - 0.5)
    }
  },
  mounted () {
    EventBus.$emit('showTitlePage', this.$t('about.pageTitle'))
    EventBus.$emit('toggleHeaderFamilyIcons', false)
    EventBus.$emit('toggleGridFamilyIcon', true)

    fadeInOutSection()
    backgroundOverlay()
    this.scrollHandler = () => {
      const footerHeight = Helper.isBottomOfPage() ? (document.getElementsByClassName('footer')[0].clientHeight) : 0
      if (document.getElementById('handstick') !== null) {
        document.getElementById('handstick').style.zIndex = Helper.isBottomOfPage() ? '-1' : 'auto'
      }
      if (document.getElementById('background-container-mobile') !== null) {
        document.getElementById('background-container-mobile').style.transform = `translateY(-${footerHeight}px)`
      }
      if (document.getElementById('about-overlay') !== null) {
        document.getElementById('about-overlay').style.transform = `translateY(-${footerHeight}px)`
      }
    }
    window.addEventListener('scroll', this.scrollHandler)

    this.vimeoPlayerOnLoad()

    EventBus.$on('toggleSliderFirstElemns', (toggle) => {
      this.sliderElemns.showMouse = toggle
      this.sliderElemns.showSliderInfo = toggle
      this.sliderElemns.showOverlay = toggle
    })
    EventBus.$on('toggleSliderFinalElemns', (toggle) => {
      this.sliderElemns.showArrow = toggle
      this.sliderElemns.showFloatingButtons = toggle
    })
    EventBus.$emit('headerFamilySelected', null)

    this.people = this.$t('team.people')
    this.sortPeople()
    this.showPeople = true

    EventBus.$emit('showTitlePage', this.$t('about.pageTitle'))
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.scrollHandler)
  },
  watch: {
    '$i18n.locale': {
      handler () {
        EventBus.$emit('showTitlePage', this.$t('about.pageTitle'))
        this.people = this.$t('team.people')
      }
    },
    showLoading: {
      handler () {
        if (!this.showLoading) {
          EventBus.$emit('toggleLoading', false)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .about{
    .hero-slider{
      .slider-content{
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        left: var(--main-space);
        mix-blend-mode: difference;
      }
    }
  }

  .about-sections-container{
    position: relative;
    z-index: 10;
  }
  .about {
    .background-container-mobile {
      background-image: url('../assets/img/about-background.jpg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
    }
    .video-container {
      width: 100%;
      height: 100%;
      z-index: -2;
      overflow: hidden;

      .video-player-container {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: calc(100vh * 16 / 9); /* 100 * 16 / 9 */
        min-width: 100%;
        min-height: calc(100vw * 9 / 16); /* 100 * 9 / 16 */

        iframe {
          width: 100%;
          height: 100%;
        }
      }

      .about-overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: #1A1A1A;
        opacity: 0;
      }
    }

    .about-description {
      font-size: 36px;
      width: 80%;
      line-height: calc(var(--main-space)/5*6);
    }

    .about-section {
      padding-top: var(--main-space);
      .title-section {
        color: #FFFFFF;
        margin-bottom: var(--main-space);
        height: 40px;
      }
    }
  }
  .wrapper {
    width: 100% !important;
    padding-inline: var(--main-space)!important;
    z-index: 2;
    position: relative;
  }

  .mision-container{
    width: 100%;
  }
  .mision-container p {
    max-width: calc(100% - 80px);
    font-size: 66px;
    line-height: 1.21;
    font-family: 'BC-Liguria', sans-serif;
  }

  .people {
    background: #1A1A1A;
    .subtit {
      width: 100%;
      position: relative;
      padding-inline: var(--main-space);
      bottom: 0;
      background: #1A1A1A;
      padding-block: 160px;
      z-index: 10;
      p {
        width: calc(100% - 80px);
        color: #8C9091 !important;
        font-size: 58px;
        line-height: 1.21;
        font-family: 'BC-Liguria', sans-serif;
      }
    }
  }
  .people-container{
    background: #1a1a1a !important;
    position: relative;
    z-index: 1000;
  }
  @media screen and (min-width: 1240px) and (max-width: 1240px)
  and (min-height: 600px) and (max-height: 800px) {
    .background-container-mobile {
      background-position: top;
      background-repeat: no-repeat;
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
    }
  }

  @media screen and (max-width: 1280px){
    .mision-container p {
      font-size: 54px;
      line-height: 1.21;
    }
  }

  @include media-breakpoint-down(lg) {
    .about {
      .about-description {
        font-size: 30px;
        line-height: 150%;
      }
    .subtit {
      width: 100%;
      position: relative;
      bottom: 0;
      z-index: 10;
      p {
        color: #8C9091 !important;
        font-size: 3rem;
      }
    }
    }
  }

  @include media-breakpoint-down(sm) {
    .about {
      .about-description {
        font-size: 16px;
        width: 90%;
      }
      .about-section {
        .title-section {
          font-size: 28px;
          height: auto;
        }
      }
    }
    .people {
      .subtit {
        p{
          font-size: 26px;
          width: 100%;
        }
      }
    }
    .mision-container {
      width: calc(100% + var(--main-space));
      padding-bottom: calc(var(--main-space) * 6);
    }
    .mision-container p {
      font-size: 26px;
      line-height: 1.2;
      width: 100%;
      max-width: inherit;
      padding-right: var(--main-space);
      // line-height: calc(var(--main-space) / 3 * 4);
      margin: 0 !important;
    }
  }
</style>
